/* eslint-disable array-callback-return*/

import { Grid, TableCell, TableRow } from "@material-ui/core";
import {
  InputTextMaster,
  Loading,
  Modal,
  TableCellDefault,
  TableWrapper,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { defaultDateDisplay, defaultToastError, formatNumber, isNull } from "App/utils/helpers";
import React, { useEffect, useState } from "react";
import { getIDGLById } from "../../helpers";

const ModalIdgl = ({ setShowModal, idgl }) => {
  const [detailIdgl, setDetailIdgl] = useState(null);
  const [totalDebit, setTotalDebit] = useState(0); //eslint-disable-line
  const [totalKredit, setTotalKredit] = useState(0); // eslint-disable-line
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    fetchDetailIDGL();
  }, [idgl]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDetailIDGL = async () => {
    setLoading(true);
    const response = await getIDGLById(idgl);
    if (response.state) {
      setDetailIdgl(response.data);
      let totalDebit = 0;
      let totalKredit = 0;

      response.data.sub_transaksi.map((item) => {
        totalDebit += item.amount_debit;
        totalKredit += item.amount_kredit;
      });
      setTotalDebit(totalDebit);
      setTotalKredit(totalKredit);
    } else {
      setDetailIdgl(null);
      defaultToastError(response.message);
    }
    setLoading(false);
  };

  return (
    <>
      <Modal title={"IDGL"} width='80%' show={setShowModal}>
        {loading ? (<>
          <div style={{ height:"300px",paddingTop:"150px" }}>
          <Loading show={loading} />
          </div>
        </>) :
          !isNull(detailIdgl) ? (
          <>
            <Transaksi transaksi={detailIdgl?.transaksi} />
            {/* <div
              style={{
                display: "flex",
              }}>
              <div
                style={{
                  padding: "1rem",
                }}>
                {formatNumber(totalDebit)}
              </div>
              <div
                style={{
                  padding: "1rem",
                }}>
                {formatNumber(totalKredit)}
              </div>
            </div> */}
            <TableSubTransaksi subTransaksi={detailIdgl?.sub_transaksi} />
          </>
        ) : (<><div>
          <center>
            <h3>Data Detail IDGL Tidak Ditemukan !</h3>
          </center>
        </div></>)
        }
         
      </Modal>
    </>
  );
};

const Transaksi = ({ transaksi }) => {
  return (
    <>
      <Grid container spacing={1}>
        <Grid item sm={3}>
          <InputTextMaster
            name='id'
            label='ID'
            id='id'
            value={transaksi?.id}
            placeholder='ID'
            disabled={true}
          />
        </Grid>

        <Grid item sm={3}>
          <InputTextMaster
            name='idgl'
            label='IDGL'
            id='idgl'
            value={transaksi?.idgl}
            placeholder='IDGL'
            disabled={true}
          />
        </Grid>

        <Grid item sm={3}>
          <InputTextMaster
            name='tgl'
            label='TANGGGAL'
            id='tgl'
            value={defaultDateDisplay(transaksi?.tgl, true)}
            placeholder='Tanggal'
            disabled={true}
          />
        </Grid>

        <Grid item sm={3}>
          <InputTextMaster
            name='no_invoice'
            label='NO INVOICE'
            id='no_invoice'
            value={transaksi?.no_invoice}
            placeholder='No Invoice'
            disabled={true}
          />
        </Grid>

        <Grid item sm={3}>
          <InputTextMaster
            name='judul'
            label='JUDUL'
            id='judul'
            value={transaksi?.judul}
            placeholder='Judul'
            disabled={true}
          />
        </Grid>

        <Grid item sm={3}>
          <InputTextMaster
            name='remark'
            label='KETERANGAN'
            id='remark'
            value={transaksi?.remark}
            placeholder='Keterangan'
            disabled={true}
          />
        </Grid>

        <Grid item sm={3}>
          <InputTextMaster
            name='tipe_gl_code'
            label='TYPE'
            id='tipe_gl_code'
            value={transaksi?.tipe_gl_code}
            placeholder='Type'
            disabled={true}
          />
        </Grid>

        <Grid item sm={3}>
          <InputTextMaster
            name='createdName'
            label='INSERTED BY'
            id='createdName'
            value={transaksi?.createdName}
            placeholder='Inserted By'
            disabled={true}
          />
        </Grid>
      </Grid>
    </>
  );
};

const TableSubTransaksi = ({ subTransaksi }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: subTransaksi,
    orderByDefault: "id",
    orderByRow: ["id", "penerima_name", "sub_penerima_name"],
  });

  return (
    <div className='mt-1'>
      <TableWrapper
        title='Daftar Sub Transaksi'
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={subTransaksi}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>
                <TableCell align='left'>{row?.id}</TableCell>
                <TableCell align='left'>{row?.idgl}</TableCell>
                <TableCell align='left'>
                  {defaultDateDisplay(row?.tgl_sub, true)}
                </TableCell>
                <TableCell align='left'>{row?.coa_code}</TableCell>
                <TableCell align='left'>{row?.coa_name}</TableCell>

                <TableCell align='left'>{row?.cc}</TableCell>
                <TableCell align='right'>
                  {formatNumber(row?.amount_debit)}
                </TableCell>
                <TableCell align='right'>
                  {formatNumber(row?.amount_kredit)}
                </TableCell>

                <TableCell align='left'>{row?.operasional}</TableCell>
                <TableCell align='left'>{row?.penerima_name}</TableCell>
                <TableCell align='left'>{row?.sub_penerima_name}</TableCell>
                <TableCell align='left'>{row?.remark}</TableCell>
                <TableCellDefault row={row} />
              </TableRow>
            );
          })}
      </TableWrapper>
    </div>
  );
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "idgl",
    disablePadding: false,
    label: "IDGL",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "tgl_sub",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "coa_code",
    disablePadding: false,
    label: "KODE COA",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "coa_name",
    disablePadding: false,
    label: "NAMA COA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "cc",
    disablePadding: false,
    label: "CC",
    align: "left",
  },
  {
    id: "amount_debit",
    disablePadding: false,
    label: "DEBIT",
    align: "left",
  },
  {
    id: "amount_kredit",
    disablePadding: false,
    label: "KREDIT",
    align: "left",
  },
  {
    id: "operasional",
    disablePadding: false,
    label: "OPERASIONAL",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "penerima_name",
    disablePadding: false,
    label: "PENERIMA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "sub_penerima_name",
    disablePadding: false,
    label: "SUB PENERIMA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "KETERANGAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export default ModalIdgl;
